const assets = {
    images: {
      logoDark: require('./images/logo-dark.png'),
      appIcon: require('./images/favicon.png'),
      logoLight: require('./images/logo-light.png'),
      logo: require('./images/logo.png')
    },
    colors: {
      secondary: '#292929',
      secondaryDark: '#0f0f0f',
      secondaryLight: '#f4f5f7'
    }
  }

  export default assets
